import { Switch as MuiSwitch } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Controller, ControllerProps } from 'react-hook-form';

export interface SwitchProps extends Omit<ControllerProps, 'render'> {
  label: string;
  disabled?: boolean;
}

export const Switch = ({ label, disabled, ...props }: SwitchProps) => {
  return (
    <FormControlLabel
      label={label}
      control={
        <Controller
          {...props}
          render={({ field }) => (
            <MuiSwitch
              {...field}
              disabled={disabled}
              checked={field.value}
              onChange={(e) => {
                if (!disabled) field.onChange(e.target.checked);
              }}
            />
          )}
        />
      }
    />
  );
};
